export const ARTICLES_REQUEST = 'ARTICLES_REQUEST';
export const ARTICLES_FAILURE = 'ARTICLES_FAILURE';
export const ARTICLES_SUCCESS = 'ARTICLES_SUCCESS';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const DELETE_ARTICLE_SUCCESS = 'DELETE_ARTICLE_SUCCESS';
export const DELETE_ARTICLE_REQUEST = 'DELETE_ARTICLE_REQUEST';
export const DELETE_ARTICLE_FAILURE = 'DELETE_ARTICLE_FAILURE';